import React, { useEffect } from 'react';
import moment from 'moment';
import Select from 'scy/Select';
import { Body, SecondarySmall } from 'scy/text';
import margin from 'scy/margin.mod.scss';
import styles from './styles.mod.scss';

export default function DeliveryTimeDropdowns({
  options,
  date,
  slot,
  selectDate,
  selectSlot
}) {
  useEffect(() => {
    if (!date && options.length) {
      selectDate(options[0]);
    }
  }, [date, options, selectDate]);

  const slots = date ? date.slots : [];

  const today = moment().format('dddd');

  function formatDateOption(dateOption) {
    const date = (dateOption || {}).date;
    if (!date) return '';
    return {
      description: moment(date)
        .format('dddd, MMMM Do')
        .replace(today, 'Today'),
      value: date
    };
  }

  function handleDateChange({ value }) {
    const option = options.find(option => option.date === value);
    selectDate(option);
    selectSlot(null);
  }

  function formatSlotOption(slot) {
    return { value: slot ? slot.description : undefined };
  }

  function handleSlotChange({ value }) {
    const slot = slots.find(slot => slot.description === value);
    selectSlot(slot);
  }

  return (
    <div className={styles.datePickerContainer}>
      <div className={margin.bottom_sm}>
        <SecondarySmall>
          Scheduled deliveries are in 1 hour windows
        </SecondarySmall>
      </div>

      <Select
        instanceId="deliveryDate"
        smallArrow
        clearable={false}
        searchable={false}
        options={options.map(formatDateOption)}
        optionRenderer={({ description }) => description}
        value={formatDateOption(date).value}
        valueRenderer={({ description }) => (
          <Body tag="span">
            {/Today/.test(description) ? 'Today' : description}
          </Body>
        )}
        onChange={handleDateChange}
        className={styles.datePickerSelect}
      />

      <Select
        instanceId="deliverySlot"
        smallArrow
        placeholder="Select a time"
        clearable={false}
        searchable={false}
        options={slots.map(formatSlotOption)}
        optionRenderer={({ value }) => value}
        value={formatSlotOption(slot).value}
        valueRenderer={({ value }) => <Body tag="span">{value}</Body>}
        onChange={handleSlotChange}
        className={styles.datePickerSelect}
      />
    </div>
  );
}
